import { render } from "./TestTypeSelector.vue?vue&type=template&id=0b1d329a"
import script from "./TestTypeSelector.vue?vue&type=script&lang=js"
export * from "./TestTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__